module.exports = __webpack_public_path__ + "img/img-credibility.13c65e69.png";